import { useParams } from 'react-router';
import { useDataRequest } from '@vivli/features/data-requests/infrastructure/hook';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { DataRequestShellFeature } from './data-request-shell.feature';

export const DataRequestFeature = () => {
    const { requestId, state } = useParams();
    const { dataRequest } = useDataRequest(requestId);

    const isInPreviewMode = state?.toLowerCase() === 'preview';

    if (!dataRequest) {
        return <LoadIndicatorCenteredView />;
    }

    return <DataRequestShellFeature dataRequest={dataRequest} isInPreviewMode={isInPreviewMode} />;
};
